import api from "../../../core/api";
import {
  CatalogSearchResult,
  CatalogModelDetail,
  CatalogManufacturer,
  CatalogCategory,
  TaperType,
} from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
}

class CatalogApi {
  searchModels(
    search?: string,
    categoryCode?: string,
    manufacturerId?: string,
    page: number = 1,
    pageSize: number = 20,
    filters?: {
      minRpm?: number;
      maxRpm?: number;
      minHp?: number;
      maxHp?: number;
      minTools?: number;
      maxTools?: number;
      taperTypeId?: string;
      controlSystemBrandId?: string;
      operationTypeId?: string;
      oemReady?: boolean;
      machineIdIntegrated?: boolean;
    }
  ): Promise<CatalogSearchResult> {
    return api.get<CatalogSearchResult>(
      `/v1/customer/catalog/models`,
      {
        ...getRequestConfig(),
        params: { search, categoryCode, manufacturerId, page, pageSize, ...filters }
      }
    ).then(x => x.data);
  }

  getTaperTypes(): Promise<TaperType[]> {
    return api.get<TaperType[]>(
      `/v1/customer/catalog/taper-types`,
      getRequestConfig()
    ).then(x => x.data);
  }

  getModelById(id: string): Promise<CatalogModelDetail> {
    return api.get<CatalogModelDetail>(
      `/v1/customer/catalog/models/${id}`,
      getRequestConfig()
    ).then(x => x.data);
  }

  getManufacturers(search?: string, categoryCode?: string): Promise<CatalogManufacturer[]> {
    return api.get<CatalogManufacturer[]>(
      `/v1/customer/catalog/manufacturers`,
      {
        ...getRequestConfig(),
        params: { search, categoryCode }
      }
    ).then(x => x.data);
  }

  getCategories(): Promise<CatalogCategory[]> {
    return api.get<CatalogCategory[]>(
      `/v1/customer/catalog/categories`,
      getRequestConfig()
    ).then(x => x.data);
  }
}

export default new CatalogApi();
